import template from './land-status.jade';
import items from '../../../enums/land-status';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.aboutObjectLandStatus', [])
    .directive('cianAfAboutObjectLandStatus', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = items;
            this.validation = validation(this.form, 'land.status', {
                required: 'Обязательное поле'
            });
        },
        controllerAs: 'landStatus',
        template,
    }))
    .name;
